import {
  Bed,
  CupSoda,
  Plane,
  FileText,
  FerrisWheel,
  CarTaxiFront,
  MicVocal,
  Check,
  Minus,
} from "lucide-react";
import { ItineraryDayBuilder } from "../models/itinerary-builder.model";

interface DayInsightsProps {
  day: ItineraryDayBuilder;
  className?: string;
}

export const DayInsights = ({ day, className = "" }: DayInsightsProps) => {
  const {
    hasCheckIn,
    hasCheckOut,
    isWithinAccommodation,
    isFreeDay,
    hasFlights,
    hasTransportation,
    hasActivities: hasDayActivities,
    accommodationId
  } = day;

  // Conta le attività per tipo
  const activityCounts = {
    accommodation: day.activities.filter(a => a.type === 'accommodation').length,
    flight: day.activities.filter(a => a.type === 'flight').length,
    transportation: day.activities.filter(a => a.type === 'transportation').length,
    activity: day.activities.filter(a => a.type === 'activity').length,
    foodDrinks: day.activities.filter(a => a.type === 'food-drinks').length,
    events: day.activities.filter(a => a.type === 'events').length,
    notes: day.activities.filter(a => a.type === 'notes').length,
  };

  const totalActivities = day.activities.length;
  const hasMultipleFlights = activityCounts.flight > 1;
  const isAccommodationChangeDay = hasCheckIn && hasCheckOut;
  const isArrivalDay = hasCheckIn && activityCounts.flight > 0;
  const isDepartureDay = hasCheckOut && activityCounts.flight > 0;
  const hasBreakfastLunchDinner = activityCounts.foodDrinks >= 3;
  const isActivityPackedDay = activityCounts.activity >= 3;
  const hasEvents = activityCounts.events > 0;
  const hasShoppingOrLeisure = day.activities.some(a =>
    a.title?.toLowerCase().includes('shopping') ||
    a.title?.toLowerCase().includes('market') ||
    a.title?.toLowerCase().includes('mall')
  );

  // Verifica se il giorno è coperto da un alloggio esistente (ma senza check-in/out in questo giorno)
  const isCoveredByAccommodation = isWithinAccommodation && !hasCheckIn && !hasCheckOut;

  // 10+ Status badges con priorità
  // const badges: Array<{ icon: JSX.Element; text: string; color: string; priority: number } | null> = [
  //   // 1. Cambio alloggio (massima priorità)
  //   isAccommodationChangeDay ? {
  //     icon: <RefreshCw className="h-3 w-3" />,
  //     text: 'Accommodation Change',
  //     color: 'bg-purple-50 text-purple-700 border-purple-200',
  //     priority: 1
  //   } : null,

  //   // 2. Giorno di arrivo (volo + check-in)
  //   isArrivalDay && !isAccommodationChangeDay ? {
  //     icon: <Sunrise className="h-3 w-3" />,
  //     text: 'Arrival Day',
  //     color: 'bg-green-50 text-green-700 border-green-200',
  //     priority: 2
  //   } : null,

  //   // 3. Giorno di partenza (check-out + volo)
  //   isDepartureDay && !isAccommodationChangeDay ? {
  //     icon: <Sunset className="h-3 w-3" />,
  //     text: 'Departure Day',
  //     color: 'bg-orange-50 text-orange-700 border-orange-200',
  //     priority: 3
  //   } : null,

  //   // 4. Check-in semplice (se non già segnalato)
  //   hasCheckIn && !isAccommodationChangeDay && !isArrivalDay ? {
  //     icon: <Home className="h-3 w-3" />,
  //     text: 'Check-in',
  //     color: 'bg-green-50 text-green-700 border-green-200',
  //     priority: 4
  //   } : null,

  //   // 5. Check-out semplice (se non già segnalato)
  //   hasCheckOut && !isAccommodationChangeDay && !isDepartureDay ? {
  //     icon: <Bed className="h-3 w-3" />,
  //     text: 'Check-out',
  //     color: 'bg-orange-50 text-orange-700 border-orange-200',
  //     priority: 5
  //   } : null,

  //   // 6. Shopping/Leisure
  //   hasShoppingOrLeisure ? {
  //     icon: <FerrisWheel className="h-3 w-3" />,
  //     text: 'Shopping Time',
  //     color: 'bg-teal-50 text-teal-700 border-teal-200',
  //     priority: 6
  //   } : null,

  //   // 7. Giorno coperto da alloggio (senza check-in/out qui)
  //   isCoveredByAccommodation ? {
  //     icon: <Bed className="h-3 w-3" />,
  //     text: 'Accommodation Active',
  //     color: 'bg-blue-50 text-blue-700 border-blue-200',
  //     priority: 7
  //   } : null,

  //   // 8. Giorno in alloggio (relax) - solo se non ci sono attività
  //   isWithinAccommodation && !hasCheckIn && !hasCheckOut && totalActivities === 0 ? {
  //     icon: <Bed className="h-3 w-3" />,
  //     text: 'Relax Day',
  //     color: 'bg-blue-50 text-blue-700 border-blue-200',
  //     priority: 8
  //   } : null,

  //   // 9. Giorno di transito
  //   isFreeDay ? {
  //     icon: <CarTaxiFront className="h-3 w-3" />,
  //     text: 'Transit Day',
  //     color: 'bg-gray-50 text-gray-700 border-gray-200',
  //     priority: 9
  //   } : null,

  //   // 10. Nessun alloggio
  //   !isWithinAccommodation && !hasCheckIn && totalActivities > 0 ? {
  //     icon: <AlertCircle className="h-3 w-3" />,
  //     text: 'No Accommodation',
  //     color: 'bg-red-50 text-red-700 border-red-200',
  //     priority: 10
  //   } : null,

  //   // 11. Giorno vuoto
  //   totalActivities === 0 && !isWithinAccommodation ? {
  //     icon: <Calendar className="h-3 w-3" />,
  //     text: 'Empty Day',
  //     color: 'bg-gray-50 text-gray-600 border-gray-200',
  //     priority: 11
  //   } : null,

  //   // 12. Giorno completo (molte cose pianificate)
  //   totalActivities >= 5 ? {
  //     icon: <CheckCircle2 className="h-3 w-3" />,
  //     text: 'Fully Planned',
  //     color: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  //     priority: 12
  //   } : null,
  // ];

  // Filtra null e ordina per priorità, prendi i primi 3-4 badge più rilevanti
  // const visibleBadges = badges
  //   .filter((badge): badge is NonNullable<typeof badge> => badge !== null)
  //   .sort((a, b) => a.priority - b.priority)
  //   .slice(0, 4);

  return (
    <div className={`bg-white border border-gray-200 rounded-lg mx-4 px-4 py-3 ${className}`}>
      <div className="flex items-center justify-between">
        {/* Left: Badges */}
        {/* {visibleBadges.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {visibleBadges.map((badge, index) => (
              <span
                key={index}
                className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md border text-xs font-medium ${badge.color}`}
              >
                {badge.icon}
                {badge.text}
              </span>
            ))}
          </div>
        )} */}

        {/* Right: Activity Counters (always visible) */}
        <div className="flex items-center gap-1 sm:gap-3 ml-auto">
          {/* Accommodation */}
          <div className={`flex items-center gap-1`}>
            { /* Accommodation icon logic:
                 - if there's an accommodation activity OR a check-in OR the day is within an accommodation -> show active accommodation icon
                 - else if it's a check-out day without a check-in -> red X
                 - else show the Home icon muted
            */}
            {(activityCounts.accommodation > 0 || hasCheckIn || isCoveredByAccommodation) ? (
              <>
                <Bed className="h-4 w-4 text-gray-900" />
                <Check className="h-4 w-4 text-green-600" />
              </>
            ) : (
              <>
                <Bed className="h-4 w-4 text-gray-300" />
                <Minus className="h-4 w-4 text-gray-300" />
              </>
            )}
            {/* accommodation has no numeric counter; icon only */}
          </div>
          {/* Activities */}
          <div className={`${activityCounts.activity > 0 ? 'flex' : 'hidden hidden md:flex md:opacity-30'} items-center justify-between w-8`}>
            <FerrisWheel className={`h-4 w-4 flex-shrink-0 ${activityCounts.activity > 0 ? 'text-gray-900' : 'text-gray-300'}`} />
            <span className={`text-xs w-4 font-medium text-center ${activityCounts.activity > 0 ? 'text-gray-900' : 'text-gray-400'}`}>
              {activityCounts.activity}
            </span>
          </div>
          {/* Flights */}
          <div className={`${activityCounts.flight > 0 ? 'flex' : 'hidden md:flex md:opacity-30'} items-center justify-between w-8`}>
            <Plane className={`h-4 w-4 flex-shrink-0 ${activityCounts.flight > 0 ? 'text-gray-900' : 'text-gray-300'}`} />
            <span className={`text-xs w-4 font-medium text-center ${activityCounts.flight > 0 ? 'text-gray-900' : 'text-gray-400'}`}>
              {activityCounts.flight}
            </span>
          </div>
          {/* Transportation */}
          <div className={`${activityCounts.transportation > 0 ? 'flex' : 'hidden hidden md:flex md:opacity-30'} items-center justify-between w-8`}>
            <CarTaxiFront className={`h-4 w-4 flex-shrink-0 ${activityCounts.transportation > 0 ? 'text-gray-900' : 'text-gray-300'}`} />
            <span className={`text-xs w-4 font-medium text-center ${activityCounts.transportation > 0 ? 'text-gray-900' : 'text-gray-400'}`}>
              {activityCounts.transportation}
            </span>
          </div>
          {/* Food & Drinks */}
          <div className={`${activityCounts.foodDrinks > 0 ? 'flex' : 'hidden hidden md:flex md:opacity-30'} items-center justify-between w-8`}>
            <CupSoda className={`h-4 w-4 flex-shrink-0 ${activityCounts.foodDrinks > 0 ? 'text-gray-900' : 'text-gray-300'}`} />
            <span className={`text-xs w-4 font-medium text-center ${activityCounts.foodDrinks > 0 ? 'text-gray-900' : 'text-gray-400'}`}>
              {activityCounts.foodDrinks}
            </span>
          </div>
          {/* Events */}
          <div className={`${activityCounts.events > 0 ? 'flex' : 'hidden hidden md:flex md:opacity-30'} items-center justify-between w-8`}>
            <MicVocal className={`h-4 w-4 flex-shrink-0 ${activityCounts.events > 0 ? 'text-gray-900' : 'text-gray-300'}`} />
            <span className={`text-xs w-4 font-medium text-center ${activityCounts.events > 0 ? 'text-gray-900' : 'text-gray-400'}`}>
              {activityCounts.events}
            </span>
          </div>
          {/* Notes */}
          <div className={`${activityCounts.notes > 0 ? 'flex' : 'hidden hidden md:flex md:opacity-30'} items-center justify-between w-8`}>
            <FileText className={`h-4 w-4 flex-shrink-0 ${activityCounts.notes > 0 ? 'text-gray-900' : 'text-gray-300'}`} />
            <span className={`text-xs w-4 font-medium text-center ${activityCounts.notes > 0 ? 'text-gray-900' : 'text-gray-400'}`}>
              {activityCounts.notes}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
